module.exports = "<textarea ng-model=\"fakeVM.value\"\r\n          ng-blur=\"applyNewValue()\"></textarea>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/policycommon/common/directives/schedules/dataItems/table/templates/Textarea.html
// module id = 1015
// module chunks = 0